import React from "react";
import styles from "./SelectorCategory.module.css";

type Props = {
  title: string;
  onClick: (e:any) => void;
  selected: boolean;
  index: number;
};

function SelectorCategory({ title, onClick, selected, index }: Props) {
  return (
    <button
      className={`${styles["macro-btn"]} ${
        selected && styles["macro-btn-sel"]
      }`}
      onClick={onClick}
      value={index}
    >
      {title}
    </button>
  );
}

export default SelectorCategory;
